import { ModelsUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchListAllConstrutosProps = {
  page: number
}

type filterListAllConstrutosProps = {
  page: number
  construto: string
  typeToService: string
}

type resetConstrutosProps = {
  cdTypeToService: number
  cdConstruto: number
}

export const fetchModelConstrutos = ({
  cdTypeToService,
  cdConstruto
}: resetConstrutosProps) => {
  return new ModelsUseCase(
    `/construto/getConstrutoText?cdConstruto=${cdConstruto}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const fetchListAllConstrutos = ({
  page = 1
}: fetchListAllConstrutosProps) => {
  return new ModelsUseCase(`/construto?page=${page}`, makeAxiosHttpClient())
}

export const filterListAllConstrutos = ({
  page = 1,
  construto,
  typeToService
}: filterListAllConstrutosProps) => {
  return new ModelsUseCase(
    `/construto/filter?construto=${construto}&tipoAvaliacao=${typeToService}&page=${page}`,
    makeAxiosHttpClient()
  )
}

export const resetConstrutos = ({
  cdTypeToService,
  cdConstruto
}: resetConstrutosProps) => {
  return new ModelsUseCase(
    `/construto/reset?cdConstruto=${cdConstruto}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const saveConstrutoModel = ({
  cdConstruto,
  cdTypeToService
}: resetConstrutosProps) => {
  return new ModelsUseCase(
    `/construto/save?cdConstruto=${cdConstruto}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const updateConstrutoModel = () => {
  return new ModelsUseCase(`/construto/update`, makeAxiosHttpClient())
}
